import * as React from "react";
import { useLazyQuery } from "@apollo/client";
import EmptyImagePre from "../../Assets/empty-box.png";
import { GET_STUDENT_ENROLLMENT_INFO } from "../../Schema/Student";
import { Popover, Typography, Stack, Avatar, Box, Chip } from "@mui/material";

export default function ViewImage({ id, profileImg, stuName }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [editData, setEditData] = React.useState(null);

  const [getStudentEnrollmentInfo] = useLazyQuery(GET_STUDENT_ENROLLMENT_INFO, {
    onCompleted: ({ getStudentEnrollmentInfo }) => {
      setEditData(getStudentEnrollmentInfo);
    },
  });

  const handlePopoverOpen = (event) => {
    getStudentEnrollmentInfo({ variables: { id: id } });
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Stack direction="column" justifyContent="center">
      <Typography
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <Stack direction="row" spacing={1} className="student-info">
          <Stack direction="column" justifyContent="center">
            <Avatar
              alt={editData?.studentName}
              // src={`${process.env.React_App_VIEW_URL}${profileImg}`}
              src={
                profileImg?.slice(0, 5) === "https"
                  ? profileImg
                  : `${process.env.React_App_VIEW_URL}${profileImg}`
              }
            />
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="student-name">{stuName}</Typography>
          </Stack>
        </Stack>
      </Typography>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Stack
          direction="row"
          spacing={3}
          padding={1.5}
          alignItems={"ceneter"}
          width={440}
        >
          <Box>
            <img
              src={
                profileImg?.slice(0, 5) === "https"
                  ? profileImg
                  : `${process.env.React_App_VIEW_URL}${profileImg}`
              }
              al="Main"
              style={{
                width: "160px",
                height: "180px",
                objectFit: "cover",
                borderRadius: "4px",
              }}
            />
          </Box>
          <Stack direction="column" spacing={1} justifyContent={"right"}>
            <Typography
              variant="h6"
              component="div"
              sx={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "#0f81c2",
                marginTop: "12px",
              }}
            >
              {editData?.studentName}
            </Typography>

            {editData?.enroll?.length === 0 ? (
              <Stack
                direction="row"
                justifyContent="center"
                className="empty-container"
                height="100%"
              >
                <Stack direction="column" justifyContent="center" spacing={1}>
                  <Stack direction="row" justifyContent="center">
                    <img
                      src={EmptyImagePre}
                      alt="icon"
                      className="empty-image"
                    />
                  </Stack>
                  <Typography className="text-title">No enrollment</Typography>
                </Stack>
              </Stack>
            ) : (
              editData?.enroll?.map((item, index) => {
                return (
                  <Stack direction={"column"} spacing={0.4} key={index}>
                    <Typography
                      variant="h5"
                      component="div"
                      sx={{
                        fontSize: "17px",
                        fontWeight: "bold",
                        color: "#0f81c2",
                      }}
                    >
                      {item.className}
                    </Typography>
                    {item?.programmeName === null ||
                      item?.programmeName === undefined ? null : (
                      <Box>
                        <Chip
                          label={item?.programmeName}
                          sx={{
                            bgcolor: "#E2F0F7",
                            borderRadius: "12px",
                            height: "24px",
                            color: "#005BFA",
                            fontWeight: "bold",
                          }}
                        />
                      </Box>
                    )}
                  </Stack>
                );
              })
            )}
          </Stack>
        </Stack>
      </Popover>
    </Stack>
  );
}
